<template>
  <div class="fixed-plugin" v-click-outside="closeDropDown">
    <div class="dropdown show-dropdown" :class="{open: isOpen}">
      <a data-toggle="dropdown">
        <i class="fa fa-cog fa-2x" @click="toggleDropDown"> </i>
      </a>
      <ul class="dropdown-menu">
        <li class="header-title">Sidebar Background</li>
        <li class="adjustments-line text-center">
          <a class="switch-trigger background-color">
            <span v-for="item in sidebarColors" class="badge filter"
                  :class="[`badge-${item.color}`,{active:item.active}]"
                  :data-color="item.color"
                  @click="changeSidebarBackground(item)"></span>
          </a>
        </li>

        <li class="header-title">Sidebar Active Color</li>
        <li class="adjustments-line text-center">
          <a class="switch-trigger active-color">
            <span v-for="item in sidebarTextColors" class="badge filter"
                  :class="[`badge-${item.color}`,{active:item.active}]"
                  :data-color="item.color"
                  @click="changeSidebarLinkColor(item)"></span>
          </a>
        </li>

        <li class="button-container">
          <div class="">
            <a :href="freeUrl" target="_blank"
               class="btn btn-info btn-block btn-fill">Get Free Demo</a>
          </div>
        </li>

        <li class="button-container">
          <div class="">
            <a :href="buyUrl" target="_blank" class="btn btn-danger btn-block btn-fill">Buy for $49</a>
          </div>
        </li>

        <li class="button-container">
          <div class="">
            <a :href="documentationLink" target="_blank" class="btn btn-default btn-block">Documentation</a>
          </div>
        </li>

        <li class="header-title">Thank you for sharing!</li>

        <li class="button-container">
          <social-sharing :url="shareUrl" inline-template
                          title="Vue Paper Dashboard PRO - Premium Bootstrap Admin Template for Vue.js"
                          hashtags="vuejs, dashboard, bootstrap" twitter-user="creativetim">
            <div>
              <network network="facebook" class="btn btn-facebook btn-icon">
                <i class="fa fa-fw fa-facebook"></i>
              </network>
              <network network="pinterest" class="btn btn-pinterest btn-icon">
                <i class="fa fa-fw fa-pinterest"></i>
              </network>
              <network network="twitter" class="btn btn-twitter btn-icon">
                <i class="fa fa-fw fa-twitter"></i>
              </network>
            </div>
          </social-sharing>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
  import Vue from 'vue'
  import SocialSharing from 'vue-social-sharing'
  import VueGitHubButtons from 'vue-github-buttons'
  import 'vue-github-buttons/dist/vue-github-buttons.css'

  Vue.use(SocialSharing)
  Vue.use(VueGitHubButtons, {useCache: true})

  export default {
    props: {
      color: {
        type: String,
        default: 'black'
      },
      textColor: {
        type: String,
        default: 'success'
      }
    },
    data () {
      return {
        documentationLink: 'https://demos.creative-tim.com/bs3/vue-paper-dashboard-pro/documentation?selectedKind=Welcome&selectedStory=to%20Vue%20Paper%20Dashboard%20PRO&full=0&down=1&left=1&panelRight=0&downPanel=storybook%2Factions%2Factions-panel',
        shareUrl: 'https://www.creative-tim.com/product/vue-paper-dashboard-pro',
        buyUrl: 'https://www.creative-tim.com/product/vue-paper-dashboard-pro',
        freeUrl: 'https://www.creative-tim.com/product/vue-paper-dashboard',
        isOpen: false,
        sidebarColors: [
          {color: 'white', active: false},
          {color: 'black', active: true},
          {color: 'brown', active: false}
        ],
        sidebarTextColors: [
          {color: 'primary', active: false},
          {color: 'info', active: false},
          {color: 'success', active: true},
          {color: 'warning', active: false},
          {color: 'danger', active: false}
        ]
      }
    },
    methods: {
      toggleDropDown () {
        this.isOpen = !this.isOpen
      },
      closeDropDown () {
        this.isOpen = false
      },
      toggleList (list, itemToActivate) {
        list.forEach((listItem) => {
          listItem.active = false
        })
        itemToActivate.active = true
      },
      changeSidebarBackground (item) {
        this.$emit('update:color', item.color)
        this.toggleList(this.sidebarColors, item)
      },
      changeSidebarLinkColor (item) {
        this.$emit('update:textColor', item.color)
        this.toggleList(this.sidebarTextColors, item)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Dashboard/Layout/SidebarSharePlugin.vue